import type { JSX } from "solid-js";
import { Show } from "solid-js";
import { TextButton } from "../../../../components/button/Button.tsx";
import type { FormApi } from "../../../../components/form/createForm.ts";

type SettingSectionEditActionsProps<T> = {
  form: FormApi<T>;
  editing: boolean;
  stopEditing: () => void;
  cancelLabel: string;
  saveLabel: string;
  savingLabel: string;
  /** Defaults to disabling saving while a required value is missing */
  saveDisabled?: boolean;
};

const SettingSectionEditActions = <T,>(props: SettingSectionEditActionsProps<T>): JSX.Element => (
  <Show when={props.editing}>
    <div class="ml-auto flex gap-2">
      <TextButton
        variant="secondary"
        size="large"
        text={props.cancelLabel}
        disabled={props.form.isSubmitting()}
        onClick={() => {
          props.form.reset();
          props.stopEditing();
        }}
      />
      <TextButton
        variant="primary"
        size="large"
        text={props.form.isSubmitting() ? props.savingLabel : props.saveLabel}
        disabled={props.saveDisabled ?? props.form.submitDisabled()}
        loading={props.form.isSubmitting()}
        onClick={() => props.form.submit()}
      />
    </div>
  </Show>
);

export default SettingSectionEditActions;
